import React from 'react';

import cx from 'classnames';
import ReactSelect from 'react-select-v1';

import './style.scss';

const showMandatory = ({ mandatory, value }) => mandatory && !value;

const OldSelect = ({
  error,
  mandatory,
  value,
  small,
  className,
  invalid,
  async,
  innerRef,
  label,
  id,
  ...props
}) => {
  const Element = async ? ReactSelect.Async : ReactSelect;

  return (
    <>
      <label htmlFor={id} style={{ display: 'none' }}>
        {label}
      </label>
      <Element
        {...props}
        ref={innerRef}
        value={value}
        id={id}
        className={cx(
          {
            mandatory: showMandatory({ mandatory, value }),
            invalid: invalid,
            error: error,
            'Select--small': small,
          },
          className
        )}
      />
    </>
  );
};

const SelectWrapper = (props) => {
  return <OldSelect {...props} />;
};

export default SelectWrapper;
